import ExportPartnerCommissionsPage from './ExportPartnerCommissionsPage';

export default ExportPartnerCommissionsPage;
